import {XhrRequest} from './XhrRequest';

export class GetRequest extends XhrRequest {

    constructor (path, options) {
        super();

        const isXml = options ? options.isXml : false;
        const token = window.localStorage.getItem('loginToken::operator');
        const clientId = window.localStorage.getItem('clientId::operator');
        let headers = {};

        if (token) {
            headers[ 'Authorization' ] = 'UMS-TOKEN ' + token;
        }

        if (clientId) {
            headers[ 'ClientId' ] = clientId;
        }

        return fetch(path, {
            method: 'get',
            headers: headers
        })
            .then((res) => {
                return isXml ? res.text() : res.json();
            })
    }
}